import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import _ from 'lodash'
import { CircularProgress } from "@material-ui/core";


const AddRole = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];


  const [name, setName] = useState("");
  const [description,setDescription]=useState()
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [allPermissions,setAllPermissions]=useState()
  const [loader,setLoader]=useState(false)


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      let name = props.location.state?.item?.name
      var description =props.location.state?.item?.description
      var status = props.location.state?.item?.status;
      setName(name)
      setDescription(description)
      setStatus(status);
      getPermissions(token,name);
    }
  }, []);

  const getPermissions = (token,rolename) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/permissions/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result) {
        const sortedArray=_.sortBy(result, (x)=>{
          return  x.module_lable.toLowerCase()
         })
         const rolePermission= sortedArray.filter((item) => item?.role_name == rolename)
         .map((item) => ({
           id: item?.module_id,
           value: item.module_name,
           label: item?.module_lable,
         }));
        setAllPermissions(rolePermission);
        }
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleSubmit = () => {
    if (!name) {
      setErrorMessage("Please Enter Role Name");
      setErrorAlert(true);
      return;
    }
     else if (!description) {
      setErrorMessage("Please Enter Description");
      setErrorAlert(true);
      return;
    } 

    setLoader(true)

    // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("name", name);
    formdata.append("description", description);
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/roles`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = () => {
    if (!name) {
        setErrorMessage("Please Enter Role Name");
        setErrorAlert(true);
        return;
      }
       else if (!description) {
        setErrorMessage("Please Enter Description");
        setErrorAlert(true);
        return;
      } 
      setLoader(true)
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    // myHeaders.append(
    //   "Cookie",
    //   "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    // );

    var formdata = new FormData();
    formdata.append("id", propsData?.item?.id);
    formdata.append("_method", "PUT");
    formdata.append("name", name);
    formdata.append("description", description);
    formdata.append("status", status);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      mimeType: "multipart/form-data",
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/roles/update`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
          setLoader(false)
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false)
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/roles");
        }}
        onConfirm={() => {
          props?.history.push("/roles");
          setSuccesAlert(false);
          setLoader(false)
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit?"Role Updated":" New Role Added"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem={props?.location.state?.edit ? "Update Role" : "Add New Role"} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Name</Label>
                              <input
                                type="text"
                                disabled={props?.location?.state?.edit}
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                                defaultValue={name}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <input
                                type="text"
                                disabled={props?.location?.state?.edit}
                                className="form-control"
                                id="nav_obj_input"
                                onChange={(e) => {
                                  setDescription(e.target.value);
                                }}
                                defaultValue={description}
                              />
                            </div>
                          </Col>
                        </Row>
                        {props?.location?.state?.edit&&<Row>
                        <Col md={4}>
                            <div className="mb-3">
                              <Label>Permissions</Label>
                              <Select
                                isMulti={true}
                                isSearchable={true}
                                placeholder={
                                  allPermissions
                                    ? "No Permissions"
                                    : "Loading..."
                                }
                                value={allPermissions}
                                defaultValue={allPermissions}
                                options={allPermissions}
                                maxMenuHeight={120}
                                menuPlacement="auto"
                                isDisabled={true}
                                required
                              />
                            </div>
                          </Col>
                        </Row>}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                        </Row>
                      </CardBody>
                    </Card>

                    <div className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/roles");
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                      disabled={loader}
                      style={{color:"#ffffff", width:"80px",marginLeft: "10px"}}
                      className={ "btn btn-success"}
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save"}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddRole;
